import SlideComponent from './SlideComponent';

export default SlideComponent;
